import { useEffect } from 'react';

import type { PluginListenerHandle } from '@capacitor/core';
import { Capacitor } from '@capacitor/core';

import { getIsOnline } from '../api';
import { setNoInternetErrorToast } from '../components/updateApp/appStatusSlice';
import { useAppDispatch } from '../store';

export const useCheckOnline = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    const checkOnline = async () => {
      const online = await getIsOnline();
      dispatch(setNoInternetErrorToast(!online));
    };

    checkOnline();
  }, [dispatch]);

  // listeners
  useEffect(() => {
    let appListener: PluginListenerHandle;
    const onlineEventHandler = () => {
      dispatch(setNoInternetErrorToast(false));
    };
    const offlineEventHandler = () => {
      dispatch(setNoInternetErrorToast(true));
    };

    if (Capacitor.isPluginAvailable('Network')) {
      (async () => {
        const { Network } = await import('@capacitor/network');
        appListener = await Network.addListener('networkStatusChange', (status) => {
          dispatch(setNoInternetErrorToast(!status.connected));
        });
      })();
    } else {
      window.addEventListener('online', onlineEventHandler);
      window.addEventListener('offline', offlineEventHandler);
    }

    return () => {
      appListener?.remove();
      window.removeEventListener('online', onlineEventHandler);
      window.removeEventListener('offline', offlineEventHandler);
    };
  }, [dispatch]);
};
